/* eslint-disable no-param-reassign -- Reason: legacy suppression retained until the owning code is migrated or cleaned up. */
export function setDomHiddenUntilFound(dom) {
    // @ts-expect-error
    dom.hidden = 'until-found';
}

export function domOnBeforeMatch(dom, callback) {
    // @ts-expect-error
    dom.onbeforematch = callback;
}
